<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 items-start gap-4 lg:gap-8 xl:gap-12 ">
        <div class="col print--hide">
            <h1 class="title">Order Complete</h1>
            <p class="my-4">
                <span class="font-bold">Your order is confirmed</span>. You’ll receive an email confirmation shortly. Get ready for unlimited swings at game-speed pitching!
            </p>
            <p class="my-4">
                <span class="font-bold">Your gift code is:</span> {{ giftCode }}
            </p>
        </div>

        <div class="col col--center">
            <div class="print-target flex items-center relative">
                <img
                    class="flex-none rounded-md object-cover"
                    src="https://winreality.com/wp-content/uploads/2023/11/train.jpg"
                    alt="A photo of a boy swinging a bat wearing a VR headset"
                >

                <div class="print--hide absolute inset-0 bg-gradient-to-b from-black to-transparent opacity-50 rounded-md"></div>

                <div class="absolute inset-0">
                    <div class="p-10 flex flex-col justify-between h-full">
                        <h2 class="text-white font-bold">USE THIS CODE TO REDEEM YOUR WIN MEMBERSHIP</h2>
                        <div
                            class="rounded-md bg-white p-4 text-center"
                        >
                            <h3>{{ giftCode }}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-y-6 my-12 print--hide">
                <button
                    class="button button--secondary flex items-center gap-x-4"
                    @click="handlePrint"
                >
                    <PrinterIcon class="w-6 h-6" />
                    <span>Print Gift Code</span>
                </button>
            </div>
        </div>

        <div class="col print--hide">
            <p>Download our mobile app</p>
            <div class="flex items-start gap-2 mt-2">
                <a href="https://apps.apple.com/app/id1600148173" target="_blank" rel="noopener">
                    <img decoding="async" src="https://winreality.com/wp-content/uploads/2023/10/DownloadAppStore.svg" title="DownloadAppStore" alt="DownloadAppStore" loading="lazy">
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.winreality&amp;pli=1" target="_blank" rel="noopener">
                    <img decoding="async" src="https://winreality.com/wp-content/uploads/2023/10/GooglePlay.svg" title="GooglePlay" alt="GooglePlay" loading="lazy">
                </a>
            </div>
            <div class="py-4 border-t-2 border-gray-300 mt-4">
                Download our <a href="https://www.meta.com/experiences/3172399986210688/" class="font-bold text-blue-500 hover:underline" target="_blank" rel="noopener">VR app</a> to your Meta Quest headset
            </div>

            <div class="py-4 border-t-2 border-gray-300">
                <a href="/refer/" class="font-bold text-blue-500 hover:underline">Refer a friend</a> and get $25 when they sign up
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { PrinterIcon } from '@heroicons/vue/24/outline'

interface Props {
    giftCode: string
}

defineProps<Props>()

const handlePrint = () => {
    window.print()
}
</script>

<style scoped>
h2 {
    color: #FFF4E8;
    font-family: At Aero;
    font-size: 26px;
    font-weight: 900;
    line-height: 32px;
    letter-spacing: -0.04em;
    text-align: left;
}

h3 {
    font-family: At Aero;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
}

.col--center {
    max-width: 768px;
}
</style>

<style>
@media print {
    .print-target {
        display: block;
        width: 400px;
        height: 400px;
        padding: 100px;
        top: calc(50% - 200px);
        left: calc(50% - 200px);
        text-align: center;
        border: 2px dashed #000;

        img {
            display: none;
        }

        .text-white {
            color: #000;
        }
    }

    .print-target * {
        text-align: center;
    }

    .print-target::before {
        content: "";
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #FFF;
        z-index: -1;
    }

    .print--hide {
        display: none;
    }
}
</style>